import PropTypes from "prop-types";
import DOMPurify from "dompurify";

UserMessage.propTypes = {
    message: PropTypes.object.isRequired,
};

export default function UserMessage({ message }) {

    // Replace urls with hyperlink
    const urlRegex = /(?:(?:https?):\/\/|www\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$])/igm;
    const messagesWithLinks = message.content.replace(urlRegex, (url) => {
        return `<a href=${ url } target="_blank" className="message-link">${ url }</a>`;
    });
    // Replace email with mailto
    const emailRegex = /([\w\-._]+@[\w.]+)/igm;
    const messagesWithEmail = messagesWithLinks.replace(emailRegex, (email) => {
        return `<a href="mailto:${ email }" className="message-link">${ email }</a>`;
    });
    const sanitizedMessages = DOMPurify.sanitize(
        messagesWithEmail, {
            ALLOWED_ATTR: ["className", "href", "target", "class", "id"]
        }
    );

    return (
        <li className="other">
            <div className="message">
                <span dangerouslySetInnerHTML={ { __html: sanitizedMessages } }/>
            </div>
            <span className="timestamp">{ new Date(message.created_at).toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true
            }) }</span>
        </li>
    );
};
